import { render, staticRenderFns } from "./CrazyRescue.vue?vue&type=template&id=42588ffe&"
import script from "./CrazyRescue.vue?vue&type=script&lang=js&"
export * from "./CrazyRescue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports